import heartOff from 'assets/images/cancellation-flow/heart-off.svg';
import errorShape from 'assets/images/error.svg';
import heart from 'assets/images/heart.svg';
import logo from 'assets/images/logo.svg';
import mailImage from 'assets/images/mail.svg';
import noWifi from 'assets/images/no-wifi.svg';
import roundCancel from 'assets/images/round-cancel.svg';
import roundCheck from 'assets/images/round-check.svg';

export enum HeaderIconSize {
  small = '24px',
  medium = '40px',
  large = '60px',
}

export interface HeaderIcon {
  icon: any;
  alt: string;
  maxWidth?: string;
}

export const headerIcons = {
  heartOff: {
    icon: heartOff,
    alt: 'components.heartOff.alt',
    maxWidth: HeaderIconSize.medium,
  },
  errorShape: {
    icon: errorShape,
    alt: 'error',
    maxWidth: HeaderIconSize.medium,
  },
  heart: {
    icon: heart,
    alt: 'heart',
    maxWidth: HeaderIconSize.medium,
  },
  logo: {
    icon: logo,
    alt: 'Femtasy logo',
    maxWidth: HeaderIconSize.large,
  },
  mailImage: {
    icon: mailImage,
    alt: 'components.ForgotPassword.Mail.alt',
    maxWidth: HeaderIconSize.medium,
  },
  noWifi: {
    icon: noWifi,
    alt: 'components.Offline.NoWifi.alt',
    maxWidth: HeaderIconSize.medium,
  },
  roundCheck: {
    icon: roundCheck,
    alt: 'components.RoundCheck.alt',
    maxWidth: HeaderIconSize.medium,
  },
  roundCancel: {
    icon: roundCancel,
    alt: 'components.AgeVerification.RoundCancel.alt',
    maxWidth: HeaderIconSize.medium,
  },
};
